import { buildQueryString } from '../../lib/query-params.ts';
import { apiClient } from '../client.ts';
import type {
  Notification,
  NotificationPreferences,
  PaginatedResponse,
} from '../types.ts';

export async function listNotifications(params?: {
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
}): Promise<PaginatedResponse<Notification>> {
  return apiClient.get<PaginatedResponse<Notification>>(`/notifications${buildQueryString(params)}`);
}

export async function getUnreadCount(): Promise<{ count: number }> {
  return apiClient.get<{ count: number }>('/notifications/unread-count');
}

export async function markAsRead(notificationId: string): Promise<Notification> {
  return apiClient.patch<Notification>(`/notifications/${notificationId}/read`);
}

export async function markAllAsRead(): Promise<void> {
  await apiClient.post('/notifications/read-all');
}

export async function deleteNotification(notificationId: string): Promise<void> {
  await apiClient.delete(`/notifications/${notificationId}`);
}

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
  return apiClient.get<NotificationPreferences>('/notifications/preferences');
}

export async function updateNotificationPreferences(
  preferences: NotificationPreferences,
): Promise<NotificationPreferences> {
  return apiClient.put<NotificationPreferences>('/notifications/preferences', preferences);
}
